__turbopack_context__.v({
  "blogPreviewSmall": "node-properties-module-scss-module__g2TlWG__blogPreviewSmall",
  "border": "node-properties-module-scss-module__g2TlWG__border",
  "button": "node-properties-module-scss-module__g2TlWG__button",
  "colorOverlay": "node-properties-module-scss-module__g2TlWG__colorOverlay",
  "colorOverlayDefault": "node-properties-module-scss-module__g2TlWG__colorOverlayDefault",
  "colorOverlayPrimary": "node-properties-module-scss-module__g2TlWG__colorOverlayPrimary",
  "contentLayer": "node-properties-module-scss-module__g2TlWG__contentLayer",
  "hAuto": "node-properties-module-scss-module__g2TlWG__hAuto",
  "hFull": "node-properties-module-scss-module__g2TlWG__hFull",
  "relative": "node-properties-module-scss-module__g2TlWG__relative",
  "video": "node-properties-module-scss-module__g2TlWG__video",
  "videoWrapper": "node-properties-module-scss-module__g2TlWG__videoWrapper",
  "w100": "node-properties-module-scss-module__g2TlWG__w100",
  "w25": "node-properties-module-scss-module__g2TlWG__w25",
  "w50": "node-properties-module-scss-module__g2TlWG__w50",
  "w75": "node-properties-module-scss-module__g2TlWG__w75",
  "wAuto": "node-properties-module-scss-module__g2TlWG__wAuto",
  "wFull": "node-properties-module-scss-module__g2TlWG__wFull",
});
